/**
 * Formatos de `payload` dos eventos U1, do ponto de vista do cliente.
 *
 * TODO(contracts): estes tipos deveriam morar em `@will/contracts` junto do
 * envelope. Hoje o contrato compartilhado tipa o envelope (`U1Envelope`) e
 * deixa o `payload` como `unknown` — de propósito, porque o catálogo de
 * eventos ainda não publicou os corpos. Enquanto isso, o cliente descreve
 * aqui o que espera ler e usa leitores tolerantes: campo ausente nunca
 * derruba a interface, no máximo vira string vazia.
 *
 * A regra é: nada neste arquivo redefine tipo do contrato. São apenas os
 * corpos que o contrato ainda não descreve.
 */

export interface TranscricaoPayload {
  /** o texto pode vir em `text` ou `delta` conforme o produtor */
  text?: string;
  delta?: string;
  final?: boolean;
  confidence?: number;
}

export interface ErroPayload {
  code?: string;
  message?: string;
  recoverable?: boolean;
}

export interface EstadoMudouPayload {
  from?: string;
  to?: string;
  reason?: string;
}

export interface FerramentaPayload {
  tool?: string;
  label?: string;
  progress?: number;
}

export interface AprovacaoPayload {
  approval_id?: string;
  summary?: string;
}

/** `true` para objetos JSON — descarta null, arrays e primitivos. */
export function ehObjeto(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

/**
 * Extrai o texto de um payload de transcrição aceitando `text` ou `delta`.
 * Produtores diferentes nomeiam o campo de formas diferentes; o cliente não
 * deve quebrar por causa disso.
 */
export function textoDaTranscricao(payload: unknown): string {
  if (!ehObjeto(payload)) return '';
  const bruto = payload['text'] ?? payload['delta'];
  return typeof bruto === 'string' ? bruto : '';
}

export function mensagemDeErro(payload: unknown): string {
  if (!ehObjeto(payload)) return 'Erro sem descrição.';
  const msg = payload['message'];
  const code = payload['code'];
  if (typeof msg === 'string' && msg !== '') return msg;
  if (typeof code === 'string' && code !== '') return `Erro ${code}.`;
  return 'Erro sem descrição.';
}

export function resumoDaAprovacao(payload: unknown): string {
  if (!ehObjeto(payload)) return '';
  const resumo = payload['summary'];
  return typeof resumo === 'string' ? resumo : '';
}
